'use client'

import Link from 'next/link'

export default function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen py-24">
            <h2 className="text-3xl font-bold mb-4">Página não encontrada</h2>
            <p className="text-gray-600 mb-8">Não conseguimos encontrar o recurso solicitado</p>
            <Link
                href="/"
                className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
            >
                Voltar para o início
            </Link>
        </div>
    )
}
